import React, { useMemo } from "react";
import BaseChart from "../../components/ui/BaseChart";
import ChartPanel from "./ChartPanel";

/**
 * Per-entity breakdown. Only ever contains entities the API returned, which are
 * the authenticated customer's own — a child customer sees a single bar for
 * itself, never a sibling.
 */
const EntityPerformanceChart = ({ entityPerformance = [], isLoading, error }) => {
  const options = useMemo(
    () => ({
      chart: { type: "bar", height: Math.max(240, entityPerformance.length * 52 + 90) },
      title: { text: null },
      legend: { align: "right", verticalAlign: "top", itemStyle: { fontSize: "11px" } },
      xAxis: {
        categories: entityPerformance.map((entity) => entity.entityName),
        labels: { style: { fontSize: "11px", color: "#6B7280" } },
        lineColor: "#E5E7EB",
      },
      yAxis: {
        title: { text: null },
        allowDecimals: false,
        gridLineColor: "#F3F4F6",
        labels: { style: { fontSize: "11px", color: "#9CA3AF" } },
      },
      tooltip: { shared: true },
      plotOptions: { bar: { borderWidth: 0, borderRadius: 3, groupPadding: 0.12 } },
      series: [
        {
          name: "Total",
          data: entityPerformance.map((entity) => entity.totalWorkOrders),
          color: "#0F40AE",
        },
        {
          name: "Completed",
          data: entityPerformance.map((entity) => entity.completedWorkOrders),
          color: "#16A34A",
        },
      ],
    }),
    [entityPerformance],
  );

  return (
    <ChartPanel
      title="Entity Breakdown"
      subtitle="Work orders per entity"
      icon="fa-solid fa-sitemap"
      accent="#7C3AED"
      accentBg="#F5F3FF"
      help="Work order volume by entity. Only entities with work scheduled in the selected date range are shown. Parent accounts are reporting groups rather than operating entities and are not listed individually; work orders raised directly against a parent account remain included in the totals above."
      isLoading={isLoading}
      error={error}
      isEmpty={entityPerformance.length === 0}
      emptyMessage="No work orders to break down by entity."
    >
      <BaseChart options={options} />
    </ChartPanel>
  );
};

export default EntityPerformanceChart;
